import DeliveryDatePicker from "components/Date/DeliveryDatePicker"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import {
  Card,
  Col,
  FormField,
  FormInput,
  Row,
} from "elemental-react16"
import { Header, Button, Modal, Dropdown,Table } from "semantic-ui-react"
import shop from "shop/shop"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import moment from "moment"

window.moment = moment
import "style/DeliveryPage.scss"
import 'react-day-picker/lib/style.css';


@observer
export default class DeliveryPage extends Component {
  
  state = {
    uploadedImages  : [],
    locations       : [],
    locationSelected: null,
    comment         : "",
    modalOpened     : false,
    tempAddressIndex: 0,
    tempAddress     : {
      mapid   : "0",
      name1   : "",
      name2   : "",
      name3   : "",
      street  : "",
      pcode   : "",
      city    : "",
      country : "",
      company : "",
      addition: "",
    }
  }
  
  handleAddressChoice = () => {
    const tempAddress = this.state.tempAddress
    const nextTempAddressIndex = this.state.tempAddressIndex + 1
    
    shop.cart.setAddress( { location: tempAddress } )
    
    this.setState( {
      locations       : [tempAddress, ...this.state.locations],
      locationSelected: tempAddress.mapid,
      modalOpened     : false,
      tempAddressIndex: nextTempAddressIndex,
      tempAddress     : {
        mapid   : `tempAddress${nextTempAddressIndex}`,
        company : "",
        name1   : "",
        name2   : "",
        name3   : "",
        street  : "",
        pcode   : "",
        city    : "",
        country : "",
        addition: "",
      }
    } )
  }
  
  toggleModal = ( toggle = false ) => {
    this.setState( { modalOpened: toggle } )
  }
  
  handleAddressFieldChange = ( evt ) => {
    const tempAddress = this.state.tempAddress
    tempAddress[ evt.target.name ] = evt.target.value
    this.setState( { tempAddress } )
  }
  
  handleLocationSelect = ( location ) => {
    console.log( `set`, location )
    this.setState( { locationSelected: location.mapid } )
    shop.cart.setAddress( { location } )
  }
  
  handleOrderIdChange = ( event ) => {
    let manual_order_id = event.target.value
    this.setState( { manual_order_id } )
    shop.cart.setExtra( "manual_order_id", manual_order_id )
  }
  handleReferenceChange = ( event ) => {
    let referenceId = event.target.value
    this.setState( { referenceId } )
    shop.cart.setExtra( "referenceId", referenceId )
  }
  
  handleCommentChange = ( event ) => {
    let comment = event.target.value
    this.setState( { comment } )
    shop.cart.setComment( { comment } )
  }
  
  handleDateChange = ( date ) => {
    let deliverdate = moment( date )
    if ( deliverdate.isValid() ) {
      deliverdate = deliverdate.format( "DD.MM.YYYY" )
      this.setState( { deliverdate } )
      shop.cart.setDeliverdate( { deliverdate } )
    } else {
      shop.cart.setDeliverdate( ({ deliverdate: "" }) )
      this.setState( { deliverdate: "" } )
    }
    
  }
  
  updateCart = ( { cart } ) => {
    let locationSelected = cart.data.deliveraddress && cart.data.deliveraddress.mapid
    if ( locationSelected ) {
      this.setState( { locationSelected } )
    }
  }
  
  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    
    // let ok = checkCartSize()
    // ok = ok && checkMinCartValue()
    // if ( !ok ) return
    
    if ( shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid ) {
      let locationSelected = shop.cart.data.deliveraddress.mapid
      this.setState( { locationSelected } )
    }
    
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        console.log( "LOCATIONS!", locations.length, { locations } )
        
        if ( locations.length < 1 ) {
          console.info( "Keine Versandadressen vorhanden" )
          return
        }


        let locationSelected = this.state.locationSelected
        const shortlist = locations.slice( 0, 5 )
        this.setState( {
          locations,
          shortlist,
          locationSelected
        } )
      } )
  }
  
  render() {
    let { uploadedImages, locations, shortlist, locationSelected, tempAddress, modalOpened } = this.state
    const attachments = shop.cart.getExtra( "attachments" )
    const deliveryLocation = locations.filter( loc => loc.mapid === locationSelected )
    let { comment, deliveraddress, deliverdate, print_receipt, comment_internal } = shop.cart.data
    let { manual_order_id,referenceId } = shop.cart.data.extras
    let billingAddress = shop.session.value || {}
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    const { hasDeliveryAddress } = shop.cart
    return (
      <div className="pb5">
        {/*HEADER STATE*/}
        {this.props.children}
        <HeaderCheckout activeStep={1} isRequest={isRequest}/>
        
        <section className="container">
          
          <div className="row-title tl">
            <h2>{translate( "your data" )}</h2>
          </div>
          <Row>
            
            <Col md="1/5" className=""><span className="black-50">{translate( "Rechnungsadresse" )}</span>
              <div className="pt3">
                <strong> {billingAddress.title}</strong> <br/>
                {billingAddress.street} <br/>
                {billingAddress.pcode} {billingAddress.city}<br/>
                {billingAddress.country}<br/>
                {billingAddress.email && <div>{billingAddress.email}</div>}
                {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </div>
            </Col>
            <Col md="1/5" className=""><span className="black-50">{translate( "Lieferadresse" )} </span>
              <div className="pt3">
                {!hasDeliveryAddress && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
                {deliveraddress && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                    
                    <div className="pt3 f6">
                      {deliveraddress.email && <div>{deliveraddress.email}</div>}
                      {deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
                    </div>
                  </div>
                </div>}
              </div>
            </Col>
            <Col md="3/5" className="">
            {
          /*<Table>
            <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{translate( "order number" )}<a style={{ color: 'red' }}>*</a></Table.HeaderCell>
                    <Table.HeaderCell>{translate( "Referenznummer" )}</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>            
                    <FormField required label={translate( "order number" )} >
                      <FormInput required placeholder={translate( "order number" )}
                         value={manual_order_id}
                         onChange={this.handleOrderIdChange}
                      />
                    </FormField>
                  </Table.Cell>
                  <Table.Cell>            <FormField label={translate( "Referenznummer" )}>
              <FormInput placeholder={translate( "Referenznummer" )}
                         value={referenceId}
                         onChange={this.handleReferenceChange}
              />
            </FormField>  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>*/
            
          
        }</Col>
            {/*<Col md="1/5" className=""><span className="black-50">{translate( "payment" )} </span>*/}
            {/*  <div className="pt3">*/}
            {/*    <strong>wie vereinbart</strong>*/}
            {/*  </div>*/}
            {/*</Col>*/}
            {/*<Col md="1/5" className=""><span className="black-50">{translate( "your message" )}
              <div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
                </span></Col>*/}
          </Row>
        
        </section>
        
        <section className="container pt4 pb4">
          <div className="row-title tl">
            <h2>{translate( "your addresses" )}</h2>
          </div>
          {console.log("checkoutfeatures: ",shop.config.checkoutFeatures)}
          {/*shop.config.checkoutFeatures.temporaryDeliveryAddress && */}
          {
          <div className="pb3">
            <TemporaryAddress
              temporaryAddress={shop.cart.data.deliveraddress}
              onSubmit={( address ) => {
                shop.cart.setDeliverAddress( address )
                this.setState( { locationSelected: false } )
                shop.toast(translate("Lieferadresse ausgewählt") + ` – ${address.pcode} ${address.city}`, "success")
              }}/>
          </div>}
          
          {locations.length > 10 ? <div>
            <Adresses onChange={this.handleLocationSelect}
                      locations={shortlist}
                      deliveryLocation={deliveryLocation}
                      locationSelected={locationSelected}/>
            <div><Link to="/checkout/delivery/addresses">{translate("Alle Adressen anzeigen")}</Link>
            </div>
          </div> : <Adresses onChange={this.handleLocationSelect}
                             locations={locations}
                             locationSelected={locationSelected}/>
          }
        
        </section>
        
        {/*<section className="container">
          <Row>
            <Col sm="2/3">
              <FormField label={translate( "comment" )}
                         htmlFor="supported-controls-input">
                <FormInput placeholder={translate( "commentPlaceholder" )}
                           value={comment}
                           onChange={this.handleCommentChange}
                           multiline/>
              </FormField>
            </Col>
          </Row>
        </section>*/}
        
        
        {/*        <section className="container">
          <div className="mw6">
        <FormField label={translate( "order number" )}>
              <FormInput placeholder={translate( "order number" )}
                         value={manual_order_id}
                         onChange={this.handleOrderIdChange}
              />
            </FormField>
            <FormField label={translate( "Referenznummer" )}>
              <FormInput placeholder={translate( "Referenznummer" )}
                         value={manual_order_id}
                         onChange={this.handleReferenceChange}
              />
            </FormField>
            
                      </div>
        </section>*/}
        
        {/*DELIVERY DATE SUGGESTION*/}
        {(shop.config.checkoutFeatures.deliverdate || shop.config.plugin.deliverdate) &&
        <section className="container">
          {/*COMMENT WITH UPLOAD */}
          {/*NORMAL COMMENT*/}
          
          <Row>
            <Col sm="2/3">
              <FormField label={translate( "delivery after" )}
                         htmlFor="supported-controls-input">
                <DeliveryDatePicker date={deliverdate} onChange={this.handleDateChange}/>
              </FormField>
            </Col>
          </Row>
        </section>
        }
        
        
        {/*ONLY FOR VERTRIEBSACCOUNTS*/}
        {(shop.session.handId && !shop.config.hideAddtionalCheckoutMetaForPowerUsers) && <div className="pt3">
          <section className="container">
            <div className="row-title tl">
              <h2>{translate( "back office" )}</h2>
            </div>
            <Row>
         
              <Col sm="1/2">
                <FormField label={translate( "Belegausdruck/Innendienst" )}
                           htmlFor="supported-controls-input">
                  <FormInput placeholder={translate( "Belegausdruck/Innendienst" )}
                             value={print_receipt}
                             onChange={event => {
                               let print_receipt = event.target.value
                               shop.cart.setExtra( "print_receipt", print_receipt )
                             }}
                             multiline/>
                </FormField>
              </Col>
            </Row>
          </section>
        </div>}
        
        <section className="pa2 mb4 ">
          <div className="container">
            <Row>
              <Col xs="1/2"
                   className="tl fl checkout-control">
                <Link to={{ pathname: "..", search: this.props.location.search }}>
                  <Button>
                    <i className="icon-angle-left"/>
                    {translate( "Zurück" )}
                  </Button>
                </Link>
              </Col>
              
              {<Col xs="1/2"
                   className="tr fr checkout-control">
                <Link to={{
                  pathname: "../confirmation",
                  search  : this.props.location.search
                }}>
                  <Button primary>
                    {translate( "WeiterShoppingCart" )}
                    <i className="icon-angle-right"/>
                  </Button>
                </Link>
              </Col>}
            </Row>
          </div>
        </section>
      </div>
    )
  }
}

const Adress = ( { location, handleSelect, isSelected } ) => {
  return (
    <div>
      <h3>{location.mapid.indexOf( "tempAddress" ) !== -1 && "Eingegebene"} {translate( "Adresse" )}</h3>
      {location.company} <br/>
      {location.name1} {location.name2} {location.name3}<br/>
      {location.street} <br/>
      {location.addition} <br/>
      {location.pcode} {location.city}<br/>
      {location.country}<br/>
      {location.extras && <React.Fragment>
        {location.extras.ShipmentMethodCodeText && <div>{location.extras.ShipmentMethodCodeText}</div>}
      </React.Fragment>}
      <div className="pt3">
        {isSelected ?
          <Button size="small" primary onClick={() => handleSelect( false )} icon={"check"}/> :
          <Button size="small" basic onClick={() => handleSelect( location )}>{translate( "auswählen" )}</Button>
        }
      </div>
      {/*<pre>{JSON.stringify(location, null, 2)}</pre>*/}
    </div>
  )
}

const Adresses = ( { locations, locationSelected, onChange, deliveryLocation } ) => {
  let addresses = locations.map( ( location, key ) => {
    // console.log( `${locationSelected} == ${location.mapid}` )
    let isSelected = locationSelected == location.mapid
    if ( isSelected && deliveryLocation && deliveryLocation.mapid ) return null
    return (<Col key={key} sm="1/3"><Card>
      <Adress isSelected={isSelected} handleSelect={onChange} location={location}/></Card>
    </Col>)
  } )
  return <Row>
    {deliveryLocation && deliveryLocation.mapid && <Col key="AB" sm="1/3"><Card>
      <Adress isSelected={true} handleSelect={onChange} location={deliveryLocation}/></Card>
    </Col>}
    {addresses}</Row>
}

const TemporaryAddress = ( { onSubmit, temporaryAddress } ) => {
  const [open, setOpen] = React.useState( false )
  const [untouched, setUntouched] = React.useState( true )
  const [address, setAddress] = React.useState( false )
  return <div>
    {open != false && <Button onClick={() => setOpen( true )}>{translate( "Neue Lieferadresse" )}</Button>}
    <Modal open={open}>
      <Modal.Header>
        <div className="flex flex-row justify-between items-center">
          <div>{translate( "Lieferadresse" )}</div>
          <Button basic circular
                  onClick={() => {
                    setOpen( false )
                  }}
                  icon="times"
          />
        </div>
      
      </Modal.Header>
      <Modal.Content>
        <TemporaryAddressForm
          untouched={untouched}
          onChange={( address ) => {
            setAddress( address )
          }}/>
      </Modal.Content>
      <Modal.Actions>
        <Button basic type="link-cancel" onClick={() => setOpen( false )}>{translate( "schließen" )}</Button>
        <Button primary className="fr" onClick={() => {
          setUntouched( false )
          if ( !address.name1 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmen" ) )
          // if ( !address.name2 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmenszusatz" ) )
          if ( !address.street ) return shop.toast( translate( "Bitte ausfüllen: Straße" ) )
          if ( !address.city ) return shop.toast( translate( "Bitte ausfüllen: Stadt" ) )
          if ( !address.pcode ) return shop.toast( translate( "Bitte ausfüllen: Postleitzahl" ) )
          onSubmit( address )
          // TODO: VALIDATE
          setOpen( false )
        }
        } type="primary">{translate( "Adresse auswählen" )}</Button>
      </Modal.Actions>
    </Modal>
  </div>
  
  // return (
  //   <div>
  //     <Modal isOpen={modalOpened} onCancel={() => handleModal( false )} backdropClosesModal>
  //       <ModalHeader text={`Neue Adresse hinzufügen`} onClose={() => handleModal( false )}/>
  //       <ModalBody>
  //         <TemporaryAddressForm handleChange={handleChange} temporaryAddress={temporaryAddress}/>
  //       </ModalBody>
  //       <ModalFooter>
  //         <Button type="link-cancel" onClick={() => handleModal( false )}>schließen</Button>
  //         <Button className="fr" type="primary" onClick={() => handleAddressChoice()}>hinzufügen</Button>
  //       </ModalFooter>
  //     </Modal>
  //
  //     <Row>
  //       <Col sm="1">
  //         <Button className="mt2" onClick={() => handleModal( true )}>temporäre Adresse hinzufügen</Button>
  //       </Col>
  //     </Row>
  //   </div>
  // )
}

const TemporaryAddressForm = ( { onChange, untouched = true, temporaryAddress = {} } ) => {
  const [form, setForm] = React.useState( Object.assign( { extras: { freecontact: "" } }, temporaryAddress ) )
  const handleChange = ( event ) => {
    const name = event.currentTarget.name
    const value = event.currentTarget.value
    const newForm = { ...form, [ name ]: value }
    setForm( newForm )
    onChange && onChange( newForm )
  }
  
  return (
    <form className={`AddressForm TemporaryAddressForm ${untouched ? "untouched" : ""}`}>
      <Row>
        <Col sm="1/3">
          <FormField label={translate( "Unternehmen" ) + "*"} htmlFor="name1">
            <FormInput maxLength={50} required type="text" name="name1" value={form.name1} onChange={handleChange}/>
          </FormField>
        </Col>
        
        <Col sm="1/3">
          <FormField label={translate( "Unternehmenszusatz" )} htmlFor="name2">
            <FormInput maxLength={50} type="text" name="name2" value={form.name2} onChange={handleChange}/>
          </FormField>
        </Col>
        
        <Col sm="1/3">
          <FormField label={translate( "Ansprechpartner" )} htmlFor="contact">
            <FormInput maxLength={50} type="text" name="freecontact" value={form.extras.freecontact} onChange={( event ) => {
              const name = event.currentTarget.name
              const value = event.currentTarget.value
              const newForm = { ...form, extras: { ...form.extras, [ name ]: value } }
              setForm( newForm )
              onChange && onChange( newForm )
              console.log( { newForm } )
            }}/>
          </FormField>
        </Col>
      
      </Row>
      
      {/*<FormField label="Firma" htmlFor="company">*/}
      {/*  <Row>*/}
      {/*    <Col sm="1">*/}
      {/*      <FormInput type="text" name="company" placeholder="Firma" value={form.company}*/}
      {/*                 onChange={handleChange}/>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*</FormField>*/}
      
      <Row>
        <Col sm="1">
          <FormField required label={translate( "Straße" ) + "*"} htmlFor="street">
            <FormInput required maxLength={50} type="text" name="street" placeholder="Straße" value={form.street}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <Row>
        <Col sm="1">
          <FormField label={translate( "Adresszusatz" )} htmlFor="addition">
            <FormInput maxLength={50} type="text" name="addition" placeholder="Adresszusatz"
                       value={form.addition}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <Row>
        <Col sm="1/5">
          <FormField maxLength={20} required label={translate( "PLZ" ) + "*"} htmlFor="pcode">
            <FormInput required type="text" name="pcode" placeholder="PLZ" value={form.pcode}
                       onChange={handleChange}/>
          </FormField>
        </Col>
        <Col sm="4/5">
          <FormField required label={translate( "Ort" ) + "*"} htmlFor="city">
            <FormInput required maxLength={30} type="text" name="city" placeholder={translate("Ort")} value={form.city}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <FormField label="Land" htmlFor="country">
        <Row>
          <Col sm="1">
            <Dropdown
              placeholder="Land"
              fluid
              search
              selection
              options={countryOptions}
              onChange={( e, { value } ) => {
                console.log( { value } )
                let fakeEvent = { currentTarget: { name: "country", value } }
                handleChange( fakeEvent )
              }}
            />
          
          </Col>
        </Row>
      </FormField>
      
      <div className="pt3">
        <p className="f6 black-80">{translate( "Für Rückfragen des Lieferdienstes" )}:</p>
        
        <Row>
          <Col sm="1/5">
            <FormField label="E-Mail" htmlFor="email">
              <FormInput maxLength={50} type="email" name="email" placeholder="E-Mail" value={form.email}
                         onChange={handleChange}/>
            </FormField>
          </Col>
          <Col sm="4/5">
            <FormField label="Telefon" htmlFor="phone">
              <FormInput maxLength={30} type="text" name="phone" placeholder="+49..." value={form.phone}
                         onChange={handleChange}/>
            </FormField>
          </Col>
        </Row>
      </div>
    </form>
  )
}


const countryOptions = [
  ["DE", "Deutschland"],
].map( e => ({ key: e[ 0 ], value: e[ 0 ], text: e[ 1 ], flag: e[ 0 ].toLowerCase() }) )


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/checkout/DeliveryPage.js